<template>
  <div class="mx-auto overflow-hidden">
    <h1 class="title">kostenlose Maschinenbewertung</h1>
    <div class="container">
      <div class="text-box">
        <h2 class="subtitle">Ihr persönlicher Beratungstermin</h2>

      </div>
      <div class="md-flex">
        <div class="input-row md-col-6">
          <h1 class="mb3 h4">Bitte wählen Sie eine Zeit und Datum für den Rückruf.</h1>
          <div class="date-time-box">
            <date-time-input></date-time-input>
          </div>
          <br />

        </div>

        <div class="input-row md-col-6 md-ml3">
          <h1 class="mb3 h4">Bitte geben Sie Ihre Kontaktinformationen an.</h1>
          
          <div class="gender-box">
            <h2 class="h-label gray">Anrede</h2>
            <input-suggestion
              type="gender_selection"
              event_name="gender_selected"
              :data_source="genderOptions"
              placeholder="Anrede wählen"
              css_class="forminput"
              :validInput="isValid"
            ></input-suggestion>
          </div>
          <br />
          
          <div class="name-box">
            <h2 class="h-label gray" v-bind:class="{ error: notfilled }">Name</h2>
            <input class="forminput" v-bind:class="{ error: not_filled_customers_name }" placeholder="Name"
              v-model="customers_name" />
          </div>
          <br />
          <div class="phone-box">
            <h2 class="h-label gray" v-bind:class="{ error: notfilled }">
              Telefonnummer
            </h2>
            <vue-tel-input mode="international" class="forminput" placeholder="Telefonnummer" :enabledFlags=false
              v-model="customers_contact_phonenumber"></vue-tel-input>
          </div>
          <br />

          <div class="email-box">
            <h2 class="h-label gray" v-bind:class="{ error: notfilled }">
              E-Mail-Adresse
            </h2>
            <input class="forminput" :class="{ error: not_filled_customers_email }" v-model="customers_email"
              placeholder="E-Mail-Adresse" />
          </div>
        </div>
      </div>

      <br />
      <div class="flex align-center">
        <div>
          <a class="abbrechen" @click="cancelAppointment()">Abbrechen</a>
        </div>
        <div>
          <submit-button :name="buttonName" :validInput="isValid" event_name="pre_submit_step_app100" />
        </div>
      </div>
    </div>
    <div class="mb4"></div>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import SubmitButton from "./SubmitButton.vue";
import DateTimeInput from "./dateTimeInput.vue";
import InputSuggestion from "./InputSuggestion.vue";
export default {
  name: "AppointmentStep01",
  props: {
    name: String,
    event_name: String,
    button_style: String,
    appointment: Boolean,
  },
  data() {
    return {
      debug: false,
      date: "",
      time: "",
      customers_name: "",
      customers_gender: "",
      customers_contact_phonenumber: "",
      customers_dsgvo: "true",
      customers_email: "",
      not_filled_customers_name: false,
      not_filled_customers_email: false,
      not_filled_customers_contact_phonenumber: false,
      not_filled_customers_dsgvo: false,
      buttonName: "Termin buchen",
      notfilled: false,
      mailValid: false,
      isValid: false,
      genderOptions: [
        { key: "Herr", val: "Herr" },
        { key: "Frau", val: "Frau" },
        { key: "Divers", val: "Divers" }
      ],
    };
  },
  mounted() {
    document.getElementsByName("telephone")[0].placeholder = "Telefonnummer";
    document.getElementsByClassName("vti__dropdown")[0].style = "display: none;"
  },
  watch: {
    customers_name: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.checkValidation();
      }
    },
    customers_contact_phonenumber: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.checkValidation();
      }
    },
    customers_dsgvo: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.checkValidation();
      }
    },
    customers_email: function () {
      //console.log("customers_email");
      if (/(.+)@(.+){2,}\.(.+){2,}/.test(this.customers_email)) {
        //console.log("test true");
        this.mailValid = true;
        this.checkValidation();
      } else {
        //console.log("test false");
        this.mailValid = false;
        this.checkValidation();
      }
    },
  },
  created() {
    EventBus.$on("update_date", (payload) => {
      this.date = payload.date;
    });
    EventBus.$on("update_time", (payload) => {
      this.time = payload.time;
    });
    EventBus.$on("gender_selected", (payload) => {
      this.customers_gender = payload.input;
    });
    EventBus.$on("pre_submit_step_app100", () => {
      let this2 = this;
      EventBus.$emit("submit_step_app100", {
        time: this2.time,
        date: this2.date,
        app_customers_name: this2.customers_name,
        app_customers_gender: this2.customers_gender,
        app_customers_email: this2.customers_email,
        app_customers_contact_phonenumber: this2.customers_contact_phonenumber,
        app_customers_dsgvo: this2.customers_dsgvo,
      });
    });


  },
  components: {
    "submit-button": SubmitButton,
    "date-time-input": DateTimeInput,
    "input-suggestion": InputSuggestion
  },
  methods: {
    log: function (obj) {
      if (this.debug) {
        this.log(obj);
      }
    },
    cancelAppointment() {
      EventBus.$emit("appointment_cancel");
    },
    checkValidation() {
      if (
        this.customers_name != "" &&
        this.customers_contact_phonenumber != "" &&
        this.customers_dsgvo != "" &&
        this.customers_email != "" &&
        this.mailValid
      ) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
  },
};
</script>

<style>
.vue-tel-input:focus-within {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 2px solid #0176CD !important;
}

/* The container */
.dsgvo-container {
  display: block;
  position: relative;
  padding-left: 48px;
  margin-top: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 14px;
  line-height: 150%;
  font-weight: 300;
  color: #515151;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.dsgvo-container-checked {
  background-color: #fff;
}

.dsgvo-container a {
  color: #515151;
  text-decoration: underline;
}

.dsgvo-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 20px;
  width: 20px;
}

.dsgvo-check {
  position: absolute;
  top: 3px;
  left: 13px;
  height: 24px;
  width: 24px;
  border: 2px solid #0176CD;
  box-sizing: border-box;
  border-radius: 5px;

}

.dsgvo-check::before {
  content: "";
  position: absolute;
  display: none;
}

.dsgvo-check::before .dsgvo-container {
  background-clip: #fff;
}

.dsgvo-container input[type="checkbox"]:checked~.dsgvo-check::before {
  display: block;
}

.dsgvo-tick {
  position: absolute;
  top: 3px;
  left: 3px;
}

.dsgvo-tick svg {
  width: 14px;
  vertical-align: text-top;
}

.subtitle {
  font-weight: 600;
  font-size: 1.5rem;
  color: #0176CD;
  margin-bottom: 2rem;
}

.input-row {
  display: flex;
  flex-direction: column;
}

.date-time-box,
.phone-box,
.name-box,
.gender-box,
.email-box {
  width: 100%;
  margin-bottom: 2rem;
}

.date-time-box,
.name-box {
  margin-right: 2rem;
}

.vue-tel-input {
  padding: 8.5px 16px !important;
}

@media (max-width: 1060px) {
  .input-row {
    flex-direction: column;
  }

  .date-time-box,
  .phone-box,
  .name-box,
  .gender-box,
  .email-box {
    width: 100%;
  }
}



</style>
